// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import { getFoodOrderById } from "../../../Servicefile/ordermanagementservice.jsx";
// import { getDeliveryOrderDetails } from "../../../Servicefile/ordermanagementservice.jsx";
// import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';

// // ============================================
// // GOOGLE MAPS CONFIG
// // ============================================
// const GOOGLE_MAP_API_KEY = "AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ";
// const mapContainerStyle = { width: '100%', height: '400px', borderRadius: '12px' };
// const defaultCenter = { lat: 17.3850, lng: 78.4867 };

// // ============================================
// // STYLES
// // ============================================
// const styles = {
//     container: {
//         padding: '24px',
//         background: '#f8f9fa',
//         maxWidth: '1600px',
//         margin: '0 auto',
//         marginTop: "50px",
//         overflow: "auto",
//         height: "90vh",
//     },
//     header: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         background: 'white',
//         padding: '16px 24px',
//         borderRadius: '12px',
//         marginBottom: '24px',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
//     },
//     backButton: {
//         padding: '8px 16px',
//         background: '#e2e8f0',
//         border: 'none',
//         borderRadius: '8px',
//         cursor: 'pointer',
//         fontWeight: '500'
//     },
//     orderSummaryCard: {
//         background: 'white',
//         padding: '24px',
//         borderRadius: '12px',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
//         marginBottom: '24px'
//     },
//     grid3col: {
//         display: 'grid',
//         gridTemplateColumns: '1fr 1fr 1fr',
//         gap: '20px',
//         marginBottom: '24px'
//     },
//     grid2col: {
//         display: 'grid',
//         gridTemplateColumns: '1fr 1fr',
//         gap: '20px',
//         marginBottom: '24px'
//     },
//     detailCard: {
//         background: 'white',
//         padding: '20px',
//         borderRadius: '12px',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
//     },
//     cardTitle: {
//         fontSize: '16px',
//         fontWeight: '700',
//         color: '#2d3748',
//         borderBottom: '2px solid #edf2f7',
//         paddingBottom: '10px',
//         marginBottom: '12px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px'
//     },
//     label: { fontWeight: '600', color: '#718096', fontSize: '13px', display: 'block', marginTop: '8px' },
//     value: { fontWeight: '500', color: '#2d3748', display: 'block' },
//     statusBadge: {
//         display: 'inline-block',
//         padding: '4px 12px',
//         borderRadius: '20px',
//         fontSize: '12px',
//         fontWeight: '600'
//     },
//     mapContainer: {
//         background: 'white',
//         padding: '20px',
//         borderRadius: '12px',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
//     },
//     itemRow: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         padding: '8px 0',
//         borderBottom: '1px solid #f1f5f9',
//         fontSize: '14px'
//     },
//     totalRow: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         paddingTop: '12px',
//         marginTop: '12px',
//         borderTop: '2px solid #edf2f7',
//         fontSize: '16px',
//         fontWeight: '700',
//         color: '#e66d33'
//     }
// };

// const FoodOrderDetailsPage = () => {
//     const { orderId } = useParams();
//     const navigate = useNavigate();
//     const { showLoader, hideLoader } = useLoader();

//     const [foodOrder, setFoodOrder] = useState(null);
//     const [deliveryOrder, setDeliveryOrder] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [mapMarkers, setMapMarkers] = useState([]);

//     useEffect(() => {
//         const fetchDetails = async () => {
//             try {
//                 showLoader();
//                 const token = localStorage.getItem("authToken");

//                 // 1. Fetch the Food Order
//                 const orderData = await getFoodOrderById(orderId, token);

//                 if (!orderData) {
//                     setError("Order not found");
//                     return;
//                 }
//                 setFoodOrder(orderData);

//                 // 2. Fetch Delivery Details if it's a delivery order
//                 let deliveryData = null;
//                 if (orderData.orderType === "DELIVERY") {
//                     try {
//                         deliveryData = await getDeliveryOrderDetails(orderId, orderData.appType, token);
//                         setDeliveryOrder(deliveryData);
//                     } catch (err) {
//                         console.warn("No delivery data found");
//                         setDeliveryOrder(null);
//                     }
//                 }

//                 // ==========================================
//                 // MAP MARKER LOGIC
//                 // ==========================================
//                 const markers = [];

//                 // 1. Vendor Marker
//                 const vLat = Number(orderData.vendorLatitude);
//                 const vLng = Number(orderData.vendorLongitude);
//                 if (vLat && vLng) {
//                     markers.push({
//                         id: 'vendor', lat: vLat, lng: vLng, label: 'Vendor', color: '#e66d33'
//                     });
//                 }

//                 // 2. User Marker
//                 const uLat = Number(orderData.userLatitude);
//                 const uLng = Number(orderData.userLongitude);
//                 if (uLat && uLng) {
//                     markers.push({
//                         id: 'user', lat: uLat, lng: uLng, label: 'Customer', color: '#2563eb'
//                     });
//                 }

//                 // 3. Rider Marker
//                 if (deliveryData) {
//                     const rLat = Number(deliveryData.deliveryPartnerLatiude);
//                     const rLng = Number(deliveryData.deliveryPartnerLongitude);
//                     if (rLat && rLng) {
//                         markers.push({
//                             id: 'rider', lat: rLat, lng: rLng, label: 'Rider', color: '#16a34a'
//                         });
//                     }
//                 }
//                 setMapMarkers(markers);

//             } catch (err) {
//                 console.error("Error fetching order details:", err);
//                 setError("Failed to load order details.");
//             } finally {
//                 setLoading(false);
//                 hideLoader();
//             }
//         };

//         if (orderId) fetchDetails();
//     }, [orderId]);

//     if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>Loading Order Details...</div>;
//     if (error) return <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>{error}</div>;

//     const getStatusColor = (status) => {
//         if (!status) return '#e2e8f0';
//         const s = status.toUpperCase();
//         if (s === 'DELIVERED' || s === 'COMPLETED') return '#48bb78';
//         if (s === 'CANCELLED') return '#fc8181';
//         if (s === 'PENDING') return '#f6e05e';
//         return '#e2e8f0';
//     };

//     return (
//         <div style={styles.container}>
//             {/* Header Section */}
//             <div style={styles.header}>
//                 <div>
//                     <h2 style={{ margin: 0 }}>Order #{orderId}</h2>
//                     <div style={{ marginTop: '4px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
//                         <span style={{ ...styles.statusBadge, background: getStatusColor(foodOrder?.status) }}>
//                             {foodOrder?.status || 'UNKNOWN'}
//                         </span>
//                         <span style={{ background: '#e2e8f0', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
//                             {foodOrder?.orderType || '-'}
//                         </span>
//                         <span style={{ background: '#e2e8f0', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
//                             {foodOrder?.paymentMethod || '-'}
//                         </span>
//                     </div>
//                 </div>
//                 <button onClick={() => navigate(-1)} style={styles.backButton}>
//                     ← Back to Orders
//                 </button>
//             </div>

//             {/* 1. ORDER DETAILS SECTION */}
//             <div style={styles.orderSummaryCard}>
//                 <h4 style={{ margin: '0 0 12px 0', color: '#e66d33' }}>Order Details</h4>

//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '12px' }}>
//                     <div>
//                         <span style={styles.label}>Order Date & Time</span>
//                         <span style={styles.value}>{new Date(foodOrder?.orderDateAndTime).toLocaleString()}</span>
//                     </div>
//                     <div>
//                         <span style={styles.label}>Transaction ID</span>
//                         <span style={styles.value}>{foodOrder?.transactionId || '-'}</span>
//                     </div>
//                     <div>
//                         <span style={styles.label}>Cancel Reason</span>
//                         <span style={styles.value}>{foodOrder?.cancelReason || 'N/A'}</span>
//                     </div>
//                     <div>
//                         <span style={styles.label}>Wallet Used</span>
//                         <span style={styles.value}>₹{(foodOrder?.walletUsed || 0).toFixed(2)}</span>
//                     </div>
//                 </div>

//                 {/* Items List */}
//                 <div style={{ background: '#fafbfc', padding: '12px', borderRadius: '8px' }}>
//                     <span style={{ fontWeight: '600', fontSize: '14px', marginBottom: '8px', display: 'block' }}>Items Ordered</span>
//                     {foodOrder?.order && foodOrder.order.length > 0 ? (
//                         foodOrder.order.map((item, idx) => (
//                             <div key={idx} style={styles.itemRow}>
//                                 <span>
//                                     {item.quantity}x <b>{item.dishName}</b> 
//                                     <span style={{ fontSize: '12px', color: '#718096' }}> ({item.category})</span>
//                                     {item.addons && item.addons.length > 0 && (
//                                         <div style={{ fontSize: '12px', color: '#718096', paddingLeft: '16px' }}>
//                                             + {item.addons.map(a => `${a.addonName} (₹${a.addonPrice})`).join(', ')}
//                                         </div>
//                                     )}
//                                 </span>
//                                 <span>₹{item.totalPrice.toFixed(2)}</span>
//                             </div>
//                         ))
//                     ) : (
//                         <span style={styles.value}>No items found</span>
//                     )}
//                 </div>

//                 {/* Price Breakdown */}
//                 <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'flex-end' }}>
//                     <div style={{ width: '300px', textAlign: 'right' }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0' }}>
//                             <span>Subtotal</span> <span>₹{(foodOrder?.subTotal || 0).toFixed(2)}</span>
//                         </div>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0' }}>
//                             <span>GST (SGST + CGST)</span> <span>₹{((foodOrder?.sgst || 0) + (foodOrder?.cgst || 0)).toFixed(2)}</span>
//                         </div>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0' }}>
//                             <span>Delivery Charges</span> <span>₹{(foodOrder?.deliveryCharges || 0).toFixed(2)}</span>
//                         </div>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0', color: '#718096' }}>
//                             <span>Packaging</span> <span>₹{(foodOrder?.packingCharges || 0).toFixed(2)}</span>
//                         </div>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0', color: '#718096' }}>
//                             <span>Platform Fees</span> <span>₹{(foodOrder?.platformCharges || 0).toFixed(2)}</span>
//                         </div>
//                         <div style={styles.totalRow}>
//                             <span>Grand Total</span> <span>₹{(foodOrder?.grandTotal || 0).toFixed(2)}</span>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* 2. USER, VENDOR, RIDER SECTIONS */}
//             <div style={deliveryOrder ? styles.grid3col : styles.grid2col}>
//                 <div style={styles.detailCard}>
//                     <div style={styles.cardTitle}>👤 Customer Details</div>
//                     <span style={styles.label}>Name</span>
//                     <span style={styles.value}>{foodOrder?.userName || '-'}</span>
//                     <span style={styles.label}>Phone</span>
//                     <span style={styles.value}>{foodOrder?.mobileNo || '-'}</span>
//                     <span style={styles.label}>Delivery Address</span>
//                     <span style={styles.value}>{foodOrder?.deliveryAddress || '-'}</span>
//                 </div>

//                 <div style={styles.detailCard}>
//                     <div style={styles.cardTitle}>🏪 Restaurant Details</div>
//                     <span style={styles.label}>Registered Name</span>
//                     <span style={styles.value}>{foodOrder?.vendorRegisteredName || '-'}</span>
//                     <span style={styles.label}>Address</span>
//                     <span style={styles.value}>{foodOrder?.vendorFullAddress || '-'}</span>
//                     <span style={styles.label}>City / State</span>
//                     <span style={styles.value}>{foodOrder?.vendorCity || '-'}, {foodOrder?.vendorState || '-'}</span>
//                 </div>

//                 {deliveryOrder && (
//                     <div style={styles.detailCard}>
//                         <div style={styles.cardTitle}>🛵 Rider Details</div>
//                         <span style={styles.label}>Rider Name</span>
//                         <span style={styles.value}>{deliveryOrder.deliveryPartnerName || '-'}</span>
//                         <span style={styles.label}>Phone Number</span>
//                         <span style={styles.value}>{deliveryOrder.deliveryPartnerPhoneNumber || '-'}</span>
//                         <span style={styles.label}>Vehicle</span>
//                         <span style={styles.value}>{deliveryOrder.vehicleStatus || 'N/A'}</span>
//                         <span style={styles.label}>Rider Earnings</span>
//                         <span style={styles.value}>₹{(deliveryOrder.earning || 0).toFixed(2)}</span>

//                     </div>
//                 )}
//             </div>

//             {/* 3. MAP SECTION (WITH CRASH FIX) */}
//             <div style={styles.mapContainer}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
//                     <h4 style={{ margin: 0 }}>📍 Location Tracking</h4>
//                     <div style={{ display: 'flex', gap: '16px' }}>
//                         {mapMarkers.map(m => (
//                             <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
//                                 <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: m.color }}></div>
//                                 <span>{m.label}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <LoadScript googleMapsApiKey={GOOGLE_MAP_API_KEY}>
//                     <GoogleMap
//                         mapContainerStyle={mapContainerStyle}
//                         center={
//                             mapMarkers.length > 0 
//                             ? { 
//                                 lat: mapMarkers.reduce((sum, m) => sum + m.lat, 0) / mapMarkers.length, 
//                                 lng: mapMarkers.reduce((sum, m) => sum + m.lng, 0) / mapMarkers.length 
//                             } 
//                             : defaultCenter
//                         }
//                         zoom={15}
//                         // ADDED onLoad TO PREVENT CRASH
//                         onLoad={() => console.log("Map Loaded Successfully")}
//                     >
//                         {mapMarkers.map(marker => (
//                             <Marker
//                                 key={marker.id}
//                                 position={{ lat: marker.lat, lng: marker.lng }}
//                                 // We moved scaledSize logic safely inside the icon object
//                                 icon={{
//                                     url: marker.id === 'vendor' 
//                                         ? 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png'
//                                         : marker.id === 'rider' 
//                                         ? 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
//                                         : 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
//                                     scaledSize: window.google && window.google.maps 
//                                         ? new window.google.maps.Size(40, 40) 
//                                         : null
//                                 }}
//                             >
//                                 <InfoWindow position={{ lat: marker.lat, lng: marker.lng }}>
//                                     <div style={{ fontSize: '14px', fontWeight: 'bold', padding: '4px' }}>
//                                         {marker.label}
//                                     </div>
//                                 </InfoWindow>
//                             </Marker>
//                         ))}
//                     </GoogleMap>
//                 </LoadScript>
//             </div>
//         </div>
//     );
// };

// export default FoodOrderDetailsPage;





import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import { getFoodOrderById } from "../../../Servicefile/ordermanagementservice.jsx";
import { getDeliveryOrderDetails } from "../../../Servicefile/ordermanagementservice.jsx";
// CHANGE 1: Remove LoadScript, keep just GoogleMap, Marker
import { GoogleMap, Marker } from '@react-google-maps/api';
// At the top of FoodOrderDetailsPage.js
import { getISTDateTime12hr, getISTDate, getISTTime } from '../../../../utils/dateTimeUtils';
// ============================================
// GOOGLE MAPS CONFIG
// ============================================
const GOOGLE_MAP_API_KEY = "AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ";
const mapContainerStyle = { width: '100%', height: '500px', borderRadius: '12px' }; // Increased to 500px
const defaultCenter = { lat: 17.3850, lng: 78.4867 };

// (Keep your 'styles' object exactly the same here) ...

// // ============================================
// // STYLES
// // ============================================
const styles = {
    container: {
        padding: '24px',
        background: '#f8f9fa',
        maxWidth: '1600px',
        margin: '0 auto',
        marginTop: "50px",
        overflow: "auto",
        height: "90vh",
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'white',
        padding: '16px 24px',
        borderRadius: '12px',
        marginBottom: '24px',
        flexDirection: "row-reverse",
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    },
    backButton: {
        padding: '8px 16px',
        background: '#e2e8f0',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontWeight: '500'
    },
    orderSummaryCard: {
        background: 'white',
        padding: '24px',
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        marginBottom: '24px'
    },
    grid3col: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '20px',
        marginBottom: '24px'
    },
    grid2col: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px',
        marginBottom: '24px'
    },
    detailCard: {
        background: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    },
    cardTitle: {
        fontSize: '16px',
        fontWeight: '700',
        color: '#2d3748',
        borderBottom: '2px solid #edf2f7',
        paddingBottom: '10px',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    label: { fontWeight: '600', color: '#718096', fontSize: '13px', display: 'block', marginTop: '8px' },
    value: { fontWeight: '500', color: '#2d3748', display: 'block' },
    statusBadge: {
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600'
    },
    mapContainer: {
        background: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    },
    itemRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 0',
        borderBottom: '1px solid #f1f5f9',
        fontSize: '14px'
    },
    totalRow: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: '12px',
        marginTop: '12px',
        borderTop: '2px solid #edf2f7',
        fontSize: '16px',
        fontWeight: '700',
        color: '#e66d33'
    }
};

const FoodOrderDetailsPage = () => {
    const { orderId } = useParams();
    const navigate = useNavigate();
    const location = useLocation()
    const { showLoader, hideLoader } = useLoader();

    // Get all tab information from URL params
    const searchParams = new URLSearchParams(location.search);
    const mainTab = searchParams.get('mainTab') || 'orders'; // FOOD& BEVERAGES, Live Orders, etc.
    const subTab = searchParams.get('subTab') || 'orders'; // orders, Live orders, etc.
    const liveSubTab = searchParams.get('liveSubTab') || 'Food orders'; // Food orders, Delivery orders


    const [foodOrder, setFoodOrder] = useState(null);
    const [deliveryOrder, setDeliveryOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [mapMarkers, setMapMarkers] = useState([]);
    // CHANGE 2: Change from mapLoaded to mapApiLoaded
    const [mapApiLoaded, setMapApiLoaded] = useState(false);

    // CHANGE 3: Add the manual script loader (Same as your GoogleMapPicker)
    useEffect(() => {
        const loadGoogleMapsScript = () => {
            if (window.google && window.google.maps) {
                setMapApiLoaded(true);
                return;
            }

            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
            script.async = true;
            script.defer = true;

            window.initGoogleMap = () => {
                setMapApiLoaded(true);
            };

            script.onload = () => {
                setMapApiLoaded(true);
            };

            document.head.appendChild(script);
        };

        loadGoogleMapsScript();
    }, []);

    // (Keep your useEffect for fetching order details exactly the same) ...
    useEffect(() => {
        const fetchDetails = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                const orderData = await getFoodOrderById(orderId, token);

                if (!orderData) {
                    setError("Order not found");
                    return;
                }
                setFoodOrder(orderData);

                let deliveryData = null;
                if (orderData.orderType === "DELIVERY") {
                    try {
                        deliveryData = await getDeliveryOrderDetails(orderId, orderData.appType, token);
                        setDeliveryOrder(deliveryData);
                    } catch (err) {
                        console.warn("No delivery data found");
                        setDeliveryOrder(null);
                    }
                }

                const markers = [];

                // 1. Vendor Marker
                const vLat = Number(orderData.vendorLatitude);
                const vLng = Number(orderData.vendorLongitude);
                // console.log("📍 Vendor Lat/Lng:", vLat, vLng);
                if (vLat && vLng) {
                    markers.push({
                        id: 'vendor', lat: vLat, lng: vLng,
                        label: 'Restaurant', color: '#e66d33',
                        address: orderData.vendorFullAddress || 'Restaurant Location',
                        name: orderData.vendorRegisteredName || 'Vendor'
                    });
                }

                // 2. Customer Marker
                const uLat = Number(orderData.userLatitude);
                const uLng = Number(orderData.userLongitude);
                // console.log("📍 Customer Lat/Lng:", uLat, uLng);
                if (uLat && uLng) {
                    markers.push({
                        id: 'customer', lat: uLat, lng: uLng,
                        label: 'Customer', color: '#2563eb',
                        address: orderData.deliveryAddress || 'Customer Location',
                        name: orderData.userName || 'Customer'
                    });
                }

                // 3. Rider Marker
                if (deliveryData) {
                    const rLat = Number(deliveryData.deliveryPartnerLatiude);
                    const rLng = Number(deliveryData.deliveryPartnerLongitude);
                    // console.log("📍 Rider Lat/Lng:", rLat, rLng);
                    if (rLat && rLng) {
                        markers.push({
                            id: 'rider', lat: rLat, lng: rLng,
                            label: 'Rider', color: '#16a34a',
                            address: 'Current Location',
                            name: deliveryData.deliveryPartnerName || 'Rider'
                        });
                    }
                }
                setMapMarkers(markers);

            } catch (err) {
                console.error("Error fetching order details:", err);
                setError("Failed to load order details.");
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        if (orderId) fetchDetails();
    }, [orderId]);

    if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>Loading Order Details...</div>;
    if (error) return <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>{error}</div>;

    // ─── Back Navigation Handler ──────────────────────────────────
    const handleBack = () => {
        // Build the URL with all tab parameters
        let path = '/foodordermanagement';
        let queryParams = [];

        if (mainTab) {
            queryParams.push(`mainTab=${mainTab}`);
        }
        if (subTab) {
            queryParams.push(`subTab=${subTab}`);
        }
        if (liveSubTab) {
            queryParams.push(`liveSubTab=${liveSubTab}`);
        }

        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
        navigate(`${path}${queryString}`);
    };

    // ─── Get Back Button Label ──────────────────────────────────
    const getBackLabel = () => {
        if (mainTab === 'Live Orders') {
            return `Live Orders - ${liveSubTab || 'Food orders'}`;
        }
        return mainTab || 'Orders';
    };

    if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>Loading Order Details...</div>;
    if (error) return <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>{error}</div>;


    const getStatusColor = (status) => {
        if (!status) return '#e2e8f0';
        const s = status.toUpperCase();
        if (s === 'DELIVERED' || s === 'COMPLETED') return '#48bb78';
        if (s === 'CANCELLED') return '#fc8181';
        if (s === 'PENDING') return '#f6e05e';
        return '#e2e8f0';
    };

    const getMapCenter = () => {
        if (mapMarkers.length === 0) return defaultCenter;
        const lat = mapMarkers.reduce((sum, m) => sum + m.lat, 0) / mapMarkers.length;
        const lng = mapMarkers.reduce((sum, m) => sum + m.lng, 0) / mapMarkers.length;
        return { lat, lng };
    };

    return (
        <div style={styles.container}>
            {/* (Keep your Header, Order Details, User/Vendor/Rider sections exactly the same) ... */}

            {/* Header Section */}
            <div style={styles.header}>
                <div>
                    <h2 style={{ margin: 0 }}>Order #{orderId}</h2>
                    <div style={{ marginTop: '4px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <span style={{ ...styles.statusBadge, background: getStatusColor(foodOrder?.status) }}>
                            {foodOrder?.status || 'UNKNOWN'}
                        </span>
                        <span style={{ background: '#e2e8f0', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                            {foodOrder?.orderType || '-'}
                        </span>
                        <span style={{ background: '#e2e8f0', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                            {foodOrder?.paymentMethod || '-'}
                        </span>
                    </div>
                </div>
                <button onClick={() => navigate(-1)} style={styles.backButton}>
                    ← Back to Orders
                </button>
                {/* <button onClick={handleBack} style={styles.backButton}>
                    ← Back to {getBackLabel()}
                </button> */}
            </div>

            {/* 1. ORDER DETAILS SECTION */}
            <div style={styles.orderSummaryCard}>
                <h4 style={{ margin: '0 0 12px 0', color: '#e66d33' }}>Order Details</h4>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '12px' }}>
                    <div>
                        <span style={styles.label}>Order Date & Time</span>
                        <span style={styles.value}>{getISTDateTime12hr(foodOrder?.orderDateAndTime)}</span>
                    </div>
                    <div>
                        <span style={styles.label}>Transaction ID</span>
                        <span style={styles.value}>{foodOrder?.transactionId || '-'}</span>
                    </div>
                    {/* Only show Cancel Reason if the order status is Cancelled */}
                    {foodOrder?.status?.toUpperCase() === 'CANCELLED' && (
                        <div>
                            <span style={styles.label}>Cancel Reason</span>
                            <span style={styles.value}>{foodOrder?.cancelReason || 'No reason provided'}</span>
                        </div>
                    )}
                    <div>
                        <span style={styles.label}>Wallet Used</span>
                        <span style={styles.value}>₹{(foodOrder?.walletUsed || 0).toFixed(2)}</span>
                    </div>
                </div>

                {/* Items List */}
                <div style={{ background: '#fafbfc', padding: '12px', borderRadius: '8px' }}>
                    <span style={{ fontWeight: '600', fontSize: '14px', marginBottom: '8px', display: 'block' }}>Items Ordered</span>
                    {foodOrder?.order && foodOrder.order.length > 0 ? (
                        foodOrder.order.map((item, idx) => (
                            <div key={idx} style={styles.itemRow}>
                                <span>
                                    {item.quantity}x <b>{item.dishName}</b>
                                    <span style={{ fontSize: '12px', color: '#718096' }}> ({item.category})</span>
                                    {item.addons && item.addons.length > 0 && (
                                        <div style={{ fontSize: '12px', color: '#718096', paddingLeft: '16px' }}>
                                            + {item.addons.map(a => `${a.addonName} (₹${a.addonPrice})`).join(', ')}
                                        </div>
                                    )}
                                </span>
                                <span>₹{item.totalPrice.toFixed(2)}</span>
                            </div>
                        ))
                    ) : (
                        <span style={styles.value}>No items found</span>
                    )}
                </div>

                {/* Price Breakdown */}
                <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ width: '300px', textAlign: 'right' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0' }}>
                            <span>Subtotal</span> <span>₹{(foodOrder?.subTotal || 0).toFixed(2)}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0' }}>
                            <span>GST (SGST + CGST)</span> <span>₹{((foodOrder?.sgst || 0) + (foodOrder?.cgst || 0)).toFixed(2)}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0' }}>
                            <span>Delivery Charges</span> <span>₹{(foodOrder?.deliveryCharges || 0).toFixed(2)}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0', color: '#718096' }}>
                            <span>Packaging</span> <span>₹{(foodOrder?.packingCharges || 0).toFixed(2)}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', padding: '2px 0', color: '#718096' }}>
                            <span>Platform Fees</span> <span>₹{(foodOrder?.platformCharges || 0).toFixed(2)}</span>
                        </div>
                        <div style={styles.totalRow}>
                            <span>Grand Total</span> <span>₹{(foodOrder?.grandTotal || 0).toFixed(2)}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 2. USER, VENDOR, RIDER SECTIONS */}
            <div style={deliveryOrder ? styles.grid3col : styles.grid2col}>
                <div style={styles.detailCard}>
                    <div style={styles.cardTitle}>👤 Customer Details</div>
                    <span style={styles.label}>Name</span>
                    <span style={styles.value}>{foodOrder?.userName || '-'}</span>
                    <span style={styles.label}>Phone</span>
                    <span style={styles.value}>{foodOrder?.mobileNo || '-'}</span>
                    <span style={styles.label}>Delivery Address</span>
                    <span style={styles.value}>{foodOrder?.deliveryAddress || '-'}</span>
                </div>

                <div style={styles.detailCard}>
                    <div style={styles.cardTitle}>🏪 Restaurant Details</div>
                    <span style={styles.label}>Registered Name</span>
                    <span style={styles.value}>{foodOrder?.vendorRegisteredName || '-'}</span>
                    <span style={styles.label}>Address</span>
                    <span style={styles.value}>{foodOrder?.vendorFullAddress || '-'}</span>
                    <span style={styles.label}>City / State</span>
                    <span style={styles.value}>{foodOrder?.vendorCity || '-'}, {foodOrder?.vendorState || '-'}</span>
                </div>

                {deliveryOrder && (
                    <div style={styles.detailCard}>
                        <div style={styles.cardTitle}>🛵 Rider Details</div>
                        <span style={styles.label}>Rider Name</span>
                        <span style={styles.value}>{deliveryOrder.deliveryPartnerName || '-'}</span>
                        <span style={styles.label}>Phone Number</span>
                        <span style={styles.value}>{deliveryOrder.deliveryPartnerPhoneNumber || '-'}</span>
                        <span style={styles.label}>Vehicle</span>
                        <span style={styles.value}>{deliveryOrder.vehicleStatus || 'N/A'}</span>
                        <span style={styles.label}>Rider Earnings</span>
                        <span style={styles.value}>₹{(deliveryOrder.earning || 0).toFixed(2)}</span>
                    </div>
                )}
            </div>

            {/* 3. MAP SECTION - FIXED */}
            <div style={styles.mapContainer}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
                    <h4 style={{ margin: 0 }}>📍 Location Tracking</h4>
                    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                        {mapMarkers.map(m => (
                            <div key={m.id} style={styles.legendItem}>
                                <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: m.color }}></div>
                                <span>{m.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* CHANGE 4: Render map ONLY after the API is loaded manually */}
                {mapApiLoaded ? (
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        center={getMapCenter()}
                        zoom={mapMarkers.length > 0 ? 14 : 12}
                        // onLoad={() => 
                        //     console.log("Map Loaded Successfully")
                        // }
                    >
                        {mapMarkers.map(marker => {
                            let iconUrl = '';
                            if (marker.id === 'vendor') {
                                iconUrl = 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png';
                            } else if (marker.id === 'rider') {
                                iconUrl = 'https://maps.google.com/mapfiles/ms/icons/green-dot.png';
                            } else {
                                iconUrl = 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png';
                            }

                            // CHANGE 5: Remove the complex condition. window.google.maps.Size is now guaranteed.
                            return (
                                <Marker
                                    key={marker.id}
                                    position={{ lat: marker.lat, lng: marker.lng }}
                                    icon={{
                                        url: iconUrl,
                                        scaledSize: new window.google.maps.Size(40, 40)
                                    }}
                                />
                            );
                        })}
                    </GoogleMap>
                ) : (
                    <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' }}>
                        <span>Loading Map...</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FoodOrderDetailsPage;